import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Text } from '@nxt-costco-com/forge-components';

export const ExplanationBox = () => {
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                fontFamily: 'typography.fontFamily',
                padding: '1rem',
                flex: 0,
            }}
        >
            <Text variant='t4'>{t('explanation')}</Text>
        </Box>
    );
};
